<script>
    import Simple from "./Symbology/Simple/Simple.svelte";
    import styleDemo from "./Symbology/actions/styleDemo";
    import {createEventDispatcher} from "svelte";

    export let styles;
    export let baseLayer = undefined;
    export let hasPolygons = true;
    export let hasPoints = true;
    export let hasLines = true;

    const dispatch = createEventDispatcher();

    function onChangeStyle(e) {
        styles = e.detail;
        dispatch('changeStyle', e.detail);
    }

</script>

<div class="editor-container">
    <Simple {styles} {hasPolygons} {hasPoints} {hasLines} on:changeStyle={onChangeStyle} />

    <div class="demo-container">
        <h4>Style preview</h4>
        <div class="style-demo" use:styleDemo={{styles, baseLayer, hasPolygons, hasPoints, hasLines}}></div>
    </div>

</div>


<style>
    /*.editor-container {
        display: grid;
        grid-template-columns: repeat(2, 50%);
        grid-template-rows: auto;
        column-gap: 1em;
        row-gap: 1em;
    }

    .editor-container :global(label) {
        display: inline-block;
        margin-bottom: 0.5em;
    }

    .editor-container :global(label input) {
        vertical-align: middle;
    }

    .demo-container {
        grid-column: 2;
        grid-row-start: 1;
        grid-row-end: 2;
    }*/

    .style-demo {
        width: 100%;
        max-width: 600px;
        height: 300px;
        background-color: #74ADCD;
    }

    .style-demo :global(.ol-attribution) {
        background-color: rgba(78,78,78,0.7);

    }

    .style-demo :global(.ol-attribution ul), .style-demo :global(.ol-attribution ul a) {
        color: #eee !important;
        text-shadow: none;
    }

    @media (max-width: 520px) {
        .editor-container {
            display: block;
        }

        .style-demo {
            width: 100%;
        }
    }
</style>